export default __webpack_public_path__ + "static/media/@jehrodriguesmakeup.cb8343fd.jpg";